import axios from 'axios';
import { getToken } from './loginVerification';

export const savePricelist = async (pricelist) => {
    const tokenData = await getToken();
    if (!tokenData.ok) {
        return { ok: false, message: 'Neprihlásený používateľ!' };
    }

    try {
        const instance = axios.create({
            headers: { 'Authorization': 'Bearer ' + tokenData.token }
        });
        const response = await instance.post(`${process.env.REACT_APP_API_HOST}/pricelist`, pricelist);
        return response.data;
    } catch (error) {
        console.error('Error saving pricelist:', error);
        return { ok: false, message: 'Chyba pri ukladaní cenníka' };
    }
};
